import { AdditionalProject } from "../../types/project";
export function ProjectRow({ project }: { project: AdditionalProject }) {
  return (
    <a
      href={project.live}
      target="_blank"
      rel="noreferrer"
      className="archive-row"
      data-reveal
    >
      <span className="archive-number">
        {project.image ? (
          <img
            src={project.image}
            alt=""
            width="72"
            height="56"
            loading="lazy"
          />
        ) : (
          project.name.slice(0, 1)
        )}
      </span>
      <div className="archive-title">
        <h3>{project.name}</h3>
        <span>{project.category}</span>
      </div>
      <p>{project.summary}</p>
      <span className="archive-arrow" aria-hidden="true">
        ↗
      </span>
    </a>
  );
}
